import { createSelector } from 'reselect';
import { makeNullSafeDomainGetter, verifyResetPasswordRequestSelector } from './common';
import { ResetPasswordStatus } from 'utils/entities';

const safeVerifyResetPasswordRequestSelector = makeNullSafeDomainGetter(verifyResetPasswordRequestSelector, 'verifyResetPasswordRequest');
export const isResetPasswordTokenValidSelector = createSelector(safeVerifyResetPasswordRequestSelector, data => data && (data.status === ResetPasswordStatus.RESET_SUCCESS || data.status === ResetPasswordStatus.RESET_TOKEN_ALREADY_USED));
